import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ConfirmModal = ({
  isOpen,
  onCancel,
  children,
}) => {
  const overlayRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    document.body.style.overflow = 'hidden';

    // Focus the dialog for accessibility
    setTimeout(() => {
      if (dialogRef.current) {
        dialogRef.current.focus();
      }
    }, 0);

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      ref={overlayRef}
      role="presentation"
      tabIndex={-1}
      className="confirm-modal-overlay"
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        className="confirm-modal-dialog"
      >
        <button
          type="button"
          aria-label="Close modal"
          className="custom-modal-close"
          onClick={onCancel}
        >
          <img src="/static/img/components/messages/close.svg" alt="Close modal" />
        </button>

        <div className="custom-modal-inner-wrapper">
          {children}
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ConfirmModal;
